<template>

</template>

<script>
export default {
  name: "ConversationPage"
}
</script>


